module.exports = __webpack_public_path__ + "img/month_no_info.598e6790.png";